import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import BookingHome from '../pages/BookingHome';
import Specialists from '../pages/Specialists';
import NotFound from './NotFound';
import {
  PAYMENT,
  PATIENT_DETAILS,
  MEDICARE,
  DOCTORS_ROUTE,
  DOCUMENTS,
  Confirmation,
  SPECIALITIES_ROUTE,
  THANKS,
  PHN_PATIENT_DETAILS,
  PHN_DOCUMENTS,
  PHN_CONFIRMATION,
  PHN_GP_DETAILS,
  PHN_REFERER_DETAILS,
  PHN_THANKS, PHN_DOCTORS_ROUTE,
} from '../constants/routes';
import { getPrivateGpDetailsConfig } from '../config/privateBooking';
import ClientDetails from '../pages/ClientDetails';
import MedicareDetails from '../pages/MedicareDetails';
import DocumentsUploading from '../pages/DocumentsUploading';
import Finish from '../pages/Finish';
import Thanks from '../pages/Thanks';
import CreditCardDetails from '../pages/CreditCardDetails';
import Specialities from '../pages/Specialities';
import HncClientDetails from '../pages/HNC/HncClientDetails';
import HncGpDetails from '../pages/HNC/HncGpDetails';
import HncRefererDetails from '../pages/HNC/HncRefererDetails';
import DocumentsAndMedicalInfo from '../pages/HNC/DocumentsAndMedicalInfo';
import HncConfirmation from '../pages/HNC/Confirmation';
import HncThanks from '../pages/HNC/HncThanks';

const isPublicBookingEnabled = process.env.REACT_APP_ENABLE_PUBLIC_BOOKING === 'true';
const isPrivateBookingEnabled = process.env.REACT_APP_ENABLE_PRIVATE_BOOKING === 'true';
const { showGpDetailsPage, showReferrerDetailsPage } = isPrivateBookingEnabled
  ? getPrivateGpDetailsConfig()
  : { showGpDetailsPage: false, showReferrerDetailsPage: false };

const RouterConfig: FC = () => (
  <Routes>
    <Route element={<BookingHome />}>
      {isPublicBookingEnabled && (
      <>
        <Route path={SPECIALITIES_ROUTE} element={<Specialities />} />
        <Route path={DOCTORS_ROUTE} element={<Specialists />} />
        <Route path={PATIENT_DETAILS} element={<ClientDetails />} />
        <Route path={DOCUMENTS} element={<DocumentsUploading />} />
        <Route path={MEDICARE} element={<MedicareDetails />} />
        <Route path={PAYMENT} element={<CreditCardDetails />} />
        <Route path={Confirmation} element={<Finish />} />
        <Route path={THANKS} element={<Thanks />} />
      </>
      )}
      {isPrivateBookingEnabled && (
      <>
        <Route path={PHN_DOCTORS_ROUTE} element={<Specialists />} />
        <Route path={PHN_PATIENT_DETAILS} element={<HncClientDetails />} />
        <Route path={PHN_DOCUMENTS} element={<DocumentsAndMedicalInfo />} />
        {/* <Route path={PHN_MEDICARE} element={<MedicareDetails />} /> */}
        {showGpDetailsPage && <Route path={PHN_GP_DETAILS} element={<HncGpDetails />} />}
        {showReferrerDetailsPage && <Route path={PHN_REFERER_DETAILS} element={<HncRefererDetails />} />}
        <Route path={PHN_CONFIRMATION} element={<HncConfirmation />} />
        <Route path={PHN_THANKS} element={<HncThanks />} />
      </>
      )}
    </Route>
    <Route path="*" element={<BookingHome><NotFound /></BookingHome>} />
  </Routes>
);

export default RouterConfig;
